import React from 'react';
import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { TextInputArea } from '@uhg-abyss/web/ui/TextInputArea';
import { CheckboxGroup } from '@uhg-abyss/web/ui/CheckboxGroup';
import { DateInput } from '@uhg-abyss/web/ui/DateInput';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
interface Option {
  label: string;
  value: string | number | undefined;
}

interface CustomerRowAddProps {
  label: string;
  type?: 'textarea' | 'checkboxGroup' | 'select' | string;
  model: string;
  options?: Option[];
  children?: React.ReactNode;
  placeHolder?: string;
  handleChange?: () => {};
}
const CustomeRowAdd: React.FC<CustomerRowAddProps> = ({
  label,
  type = '',
  children,
  handleChange,
  model,
  options = [],
  placeHolder,
  ...rest
}) => {
  const { css: inputCss, ...inputProps } = rest as any;
  const withFontSize = (slot: string) => ({
    ...inputCss,
    [slot]: {
      ...(inputCss?.[slot] || {}),
      fontSize: 'var(--abyss-fontSizes-web-core-fontSize-p-60) !important',
    },
  });

  const renderInputField = () => {
    switch (type) {
      case 'empty':
        return '';
      case 'textarea':
        return (
          <TextInputArea
            label={''}
            placeholder=""
            model={model}
            {...rest}
            isClearable={false}
          />
        );

      case 'checkboxGroup':
        return (
          <CheckboxGroup label={''} model={model} {...rest}>
            {options.map(({ label, value }) => (
              <CheckboxGroup.Column
                key={value == null ? undefined : String(value)}
              >
                <Checkbox
                  label={label}
                  value={value == null ? undefined : String(value)}
                />
              </CheckboxGroup.Column>
            ))}
          </CheckboxGroup>
        );
      case 'date':
        return (
          <TextInput
            label="Date Mask"
            mask="date"
            model={model}
            placeholder={'mm/dd/yyyy'}
            css={withFontSize('abyss-text-input')}
          />
        );
      case 'select':
        return (
          <SelectInput
            label={label}
            placeholder=""
            model={model}
            onChange={handleChange}
            isClearable
            options={options}
            {...inputProps}
            css={withFontSize('abyss-select-input-container')}
          />
        );
      case 'selec':
        return (
          <SelectInput
            label={label}
            placeholder=""
            model={model}
            onChange={handleChange}
            isClearable
            options={options}
            {...inputProps}
            css={withFontSize('abyss-select-input-container')}
          />
        );
      default:
        return (
          <TextInput
            label={label}
            model={model}
            {...inputProps}
            placeholder={placeHolder ?? ''}
            css={withFontSize('abyss-text-input')}
          />
        );
    }
  };
  return (
    <Table.Row>
      <Table.Cell>
        <strong>{label}</strong>
      </Table.Cell>
      <Table.Cell>{renderInputField()}</Table.Cell>
      {children && <Table.Cell>{children}</Table.Cell>}
    </Table.Row>
  );
};

export default CustomeRowAdd;
